import { ArdoqId, Maybe, DashboardFilterValues } from '@ardoq/api-types';
import { SelectedBranch, LoadedDashboard, MAINLINE } from '@ardoq/dashboard';
import { LoadedDashboardsState } from './loadedDashboards$';
import { isEqual, isNull } from 'lodash';

const getLoadedDashboardBranchData = (
  loadedDashboardsState: LoadedDashboardsState,
  dashboardId: ArdoqId,
  branchId: SelectedBranch
): Maybe<LoadedDashboard> =>
  loadedDashboardsState.loadedDashboards[dashboardId]?.[branchId] ?? null;

const getLoadedDashboardData = (
  loadedDashboardsState: LoadedDashboardsState,
  dashboardId: ArdoqId
): Maybe<LoadedDashboard> =>
  getLoadedDashboardBranchData(loadedDashboardsState, dashboardId, MAINLINE);

const hasCachedDashboardForFilters = (
  loadedDashboardsState: LoadedDashboardsState,
  dashboardId: ArdoqId,
  branchId: SelectedBranch,
  globalFilterValues: DashboardFilterValues | undefined
): boolean => {
  const cachedDashboard = getLoadedDashboardBranchData(
    loadedDashboardsState,
    dashboardId,
    branchId
  );
  if (isNull(cachedDashboard)) return false;
  return isEqual(
    cachedDashboard.globalFilterValues ?? {},
    globalFilterValues ?? {}
  );
};

export const loadedDashboardsOperations = {
  getLoadedDashboardBranchData,
  getLoadedDashboardData,
  hasCachedDashboardForFilters,
};
